const Funcionario = {
    id: 0,
    nome: "",
    ativo: true,
    criadoEm: "",
    atualizadoEm: ""
}

export default Funcionario;